<template>
    <tag-picker :space="space" :exclude="exclude_ids" @select="select">
        <i class="fas fa-tag"></i>
    </tag-picker>
</template>

<script>
import { mapState } from 'vuex';
import _find from 'lodash/find';
import _map from 'lodash/map';
import { copy } from '../../utils/helpers';
import get_query_list from '../../utils/router';
import TagPicker from '../tag/TagPicker.vue';

export default {
    name: 'NoteListTagsFilter',
    components: { TagPicker },
    props: ['space'],
    computed: {
        ...mapState('tags', ['filter_tags']),
        exclude_ids() {
            return _map(this.filter_tags, 'id');
        },
    },
    methods: {
        select(selected) {
            if (_find(this.filter_tags, { id: selected.id })) {
                return;
            }

            this.$store.commit('tags/add_filter_tags', [selected]);
            const tag_ids = get_query_list(this.$route.query.tags).map(Number);
            const query = copy(this.$route.query);
            query.tags = [...tag_ids, selected.id];
            this.$router.push({ name: 'content', params: this.$route.params, query });
        },
    },
};
</script>
